import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import RevolutionizeImg from "../../images/location_new/fold7/Dallas.webp";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Revolutionize(props) {
  return (
    <div className="revolutionize_section">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Why Choose TekRevol for Custom Software Development in Dallas?
            </h2>
            <p>
              There are multiple reasons to choose TekRevol when it comes to
              custom software development in Dallas. Every aspect of our
              development process is well-sorted and that is why we can serve
              our clients in the best way. We have a long history of delivering
              outstanding mobile apps, earning recognition in the industry, and
              achieving successful results. Our team excels in creating tailored
              mobile apps that precisely match your business's unique
              requirements. We consistently stay ahead in the rapidly evolving
              field of mobile technology by utilizing the latest tools and
              frameworks to build future-proof apps.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="revolutionize_img"
          >
            <LazyLoadImage
              src={RevolutionizeImg}
              effect="blur"
              alt="Image"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Revolutionize;
